import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as PupilLinkActions from './pupil-link.actions';
import {
  selectPupilLinkActionInProgressId,
  selectPupilLinkError,
  selectPupilLinkLoading,
  selectPupilLinkMismatches
} from './pupil-link.selectors';
import { AppState } from '../app.reducer';
import { PupilLinkMismatch } from '@core/models/domain/pupil-link.domain';

@Injectable({ providedIn: 'root' })
export class PupilLinkStoreFacade {
  mismatches$: Observable<PupilLinkMismatch[]> = this.store.select(selectPupilLinkMismatches);
  loading$: Observable<boolean> = this.store.select(selectPupilLinkLoading);
  error$: Observable<string | null> = this.store.select(selectPupilLinkError);
  actionInProgressId$: Observable<string | null> = this.store.select(selectPupilLinkActionInProgressId);

  constructor(private store: Store<AppState>) {}

  loadMismatches(): void {
    this.store.dispatch(PupilLinkActions.loadMismatches());
  }

  resolve(mismatchId: string, selectedPupilAccountId: string): void {
    this.store.dispatch(PupilLinkActions.resolveMismatch({ request: { mismatchId, selectedPupilAccountId } }));
  }

  createPupil(mismatchId: string): void {
    this.store.dispatch(PupilLinkActions.createPupil({ mismatchId }));
  }

  dismiss(mismatchId: string): void {
    this.store.dispatch(PupilLinkActions.dismissMismatch({ mismatchId }));
  }
}
